import { render, staticRenderFns } from "./TitleDetailPosterWithInfo.vue?vue&type=template&id=2c60a1c2&scoped=true"
import script from "./TitleDetailPosterWithInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailPosterWithInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetailPosterWithInfo.vue?vue&type=style&index=0&id=2c60a1c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c60a1c2",
  null
  
)

export default component.exports